<template>
  <div class="specs">
    <header-box :title="title" :intro="intro"></header-box>
    <div class="specs__innerwrap">
      <div class="specs__blocks">
        <div class="specs__block">
          <iframe class="specs__pdf-iframe no-swipe-nav" :src="pdfIframe"></iframe>
        </div>
        <div class="specs__block" v-for="block in contentBlocks">

          <div class="specs__block-image" v-if="(block.imagePosition === 'left')">
            <movie-player v-if="block.video" class="specs__block-video" :movieUrl="block.video" :placeholderUrl="block.image" autoplay="true"></movie-player>
            <img v-if="!block.video" :src="block.image" />
          </div>

          <div class="specs__block-textwrap"> 
            <h2 class="specs__block-title" v-html="block.title"></h2>
            <div class="specs__block-content" v-html="block.content"></div>
          </div>

          <div class="specs__block-image" v-if="(block.imagePosition === 'right')">
            <movie-player v-if="block.video" class="specs__block-video" :movieUrl="block.video" :placeholderUrl="block.image" autoplay="true"></movie-player>
            <img v-if="!block.video" :src="block.image" />
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PrevNextNav from '@/components/PrevNextNav';
import HeaderBox from '@/components/HeaderBox';
import MoviePlayer from '@/components/MoviePlayer';

export default {
  name: 'specs',
  components: { PrevNextNav, HeaderBox, MoviePlayer },
  data() {
    return {
      playing: false,
      paused: true,
    };
  },
  computed: {
    ...mapGetters(['page']),
    title() {
      return this.page.title;
    },
    intro() {
      return this.page.intro;
    },
    pdfUrl() {
      if (this.page.pdfUrl.indexOf('static') === 0) {
        return `../../${this.page.pdfUrl}`;
      }
      return this.page.pdfUrl;
    },
    pdfIframe() {
      return `static/pdf-js-viewer/index.html?file=${this.pdfUrl}`;
    },
    contentBlocks() {
      return this.page.contentBlocks;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../../scss/helpers';

.specs {
  @include page;

  &__pdf-iframe {
    height: 250px;
    width: 100%;
    display: block;
    background: $c_white;
    border: 0;

    @include not-mobile {
      margin: 0 0 0 14%;
      height: 390px;
      width: 86%;
    }

    @include landscape {
      width: 100%;
      margin: 0;
      height: 250px;
    }
  }

  &__blocks {
    box-sizing: border-box;
  }

  &__block {
    box-sizing: border-box;
    padding-bottom: 20px;
    display: flex;
    flex-direction: column;

    @include not-mobile {
      flex-direction: row;
      padding-bottom: 40px;
    }

    @include tablet {
      display: block;
    }

    @include landscape {
      display: flex;
      flex-direction: row;
      padding-bottom: 20px;
    }
  }

  &__block-image {
    display: block;
    position: relative;
    overflow: hidden;

    @include tablet {
      width: calc(66.66% - 10px);
    }

    @include landscape {
      width: 50%;
    }

    @include not-tablet {
      width: 50%;
    }

    img {
      display: block;
      width: 100%;
    }
  }

  // &__block-video {
  //   width: 100%;
  //   display: block;
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   right: 0;
  //   transition: opacity .5s;

  //   &.hide {
  //     opacity: 0;
  //     pointer-events: none;
  //   }
  // }

  &__block-textwrap + &__block-image {
    @include tablet {
      margin-left: calc(33.33% + 10px);
    }

    @include landscape {
      margin: 0;
    }
  }

  &__block-textwrap {
    box-sizing: border-box;
    background: $c_white;
    padding: 35px 30px;

    @include mobile {
      order: 1;
    }

    @include tablet {
      width: calc(66.66% - 10px);
      margin-bottom: -40px;
      padding: 40px 40px 80px;
    }

    @include landscape {
      order: unset;
      width: 50%;
      padding: 35px 30px;
      margin: 0;
    }

    @include not-tablet {
      width: 50%;
      padding: 40px;
    }

    @include desktop {
      width: 33.33%;
      margin-left: 16.665%;
    }
  }

  &__block-image + &__block-textwrap {
    @include tablet {
      margin-left: calc(33.33% + 10px);
      margin-top: -40px;
      margin-bottom: 0;
      padding: 80px 40px 40px;
    }

    @include landscape {
      margin: 0;
      padding: 35px 30px;
    }

    @include not-tablet {
      margin-left: 0;
    }
  }

  &__block-title {
    @include font-block-title;
  }

  &__block-content {
    @include font-block-content;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/templates/Specs.vue